exports.components = {
  "component---src-templates-template-article-all-js": () => import("./../../../src/templates/template-article-all.js" /* webpackChunkName: "component---src-templates-template-article-all-js" */),
  "component---src-templates-template-article-js": () => import("./../../../src/templates/template-article.js" /* webpackChunkName: "component---src-templates-template-article-js" */)
}

